import { isVerifyEmailPath } from '@/apps/verifyEmail/helpers/paths';

/**
 * Client-side route gating for the persistent email-verification banner.
 * Eligibility (existing cohort + unverified) comes from GraphQL `showBanner`;
 * this only hides the banner on surfaces where authenticated nav chrome is not the focus.
 */
export function shouldShowEmailVerificationBanner(showBanner: boolean, currentPath: string): boolean {
  if (!showBanner) {
    return false;
  }

  if (isVerifyEmailPath(currentPath)) {
    return false;
  }

  const excludedRoutes = ['/registration', '/upgrade', '/bh-benefits', '/job-post'];
  if (excludedRoutes.some((route) => currentPath.startsWith(route))) {
    return false;
  }

  return true;
}

export default shouldShowEmailVerificationBanner;
